@if (!task?.hasUserHandlePermission || !hasPermission) {
	<status-bar class="warning" icon="fa fa-warning" text="{{ 'tasks.alert_no_permissions' | translate }}" />
}

@if (task) {
	<div class="tasks-detail">
		<section>
			@if (task.recordType !== "WOUNDCARE") {
				<h3>
					{{ task.name | language }}
					@if (task.index && !task.unplanned) {
						<span> ({{ task.index }})</span>
					}
					@if (task.executed) {
						<i class="fa fa-check right"></i>
					}
				</h3>
			} @else {
				<div class="flex-container-column gap-5">
					<h3>
						{{ task.woundCare.category.name | language }} -
						{{ "wound_care.body." + task.woundCare.bodyPart | translate }}
						@if (task.index && !task.unplanned) {
							<span> ({{ task.index }})</span>
						}
						@if (task.executed) {
							<i class="fa fa-check right"></i>
						}
					</h3>
					@if (breadcrumbs) {
						<div>
							{{ breadcrumbs }}
						</div>
					}
				</div>
			}

			@if (task.executed) {
				<small>{{ task.user | name }} - {{ task.date | elapsed }}</small>
			}
			@if (task.individualPlan) {
				<div class="flex-container-column gap-10 margin-top-10">
					@if (task.individualPlan.notes) {
						<div class="flex-container-column gap-5 bg-white padding-10 border-1-solid-grey">
							<h4>{{ "tasks.individualPlan" | translate }}</h4>
							<pre data-test="task-extra-info">{{ task.individualPlan.notes }}</pre>
						</div>
					}
					@if (task.individualPlan.options) {
						<div class="protocol flex-container-column gap-5 bg-white padding-10 border-1-solid-grey">
							<h4>{{ "tasks.protocol" | translate }}</h4>
							<ul>
								@for (option of task.individualPlan.options; track option) {
									<li data-test="task-option">
										{{ option?.name | language }}
									</li>
								}
							</ul>
						</div>
					}
				</div>
			} @else {
				<p>
					{{ "tasks.noPlan" | translate }}
				</p>
			}
			@if (!task.dynamic) {}
		</section>

		<div class="tasks-detail__form">
			<ic-tasks-update-form
				[disabled]="!hasPermission"
				[formConfig]="formConfig"
				[task]="task"
				(create)="onCreate($event)"
			/>
		</div>
	</div>
}
